import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getCategoriesDataView } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";

const mapStateToProps = (state: ApplicationState) => {
    const categoriesDataView = getCategoriesDataView(state);
    const location = getLocation(state);
    const categoryPath =
        getSelectedCategoryPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);

    const catalogPageState = getCatalogPageStateByPath(state, categoryPath);

    return {
        categoriesDataView,
        state,
        catalogPageState,
    };
};

export interface CategorySpecificationStyles {
    wrapper?: InjectableCss;
}

export const categorySpecificationStyles: CategorySpecificationStyles = {
    wrapper: {
        css: css`
        & h2{
                color: #2D3435;
            }
            & h3{
                color: #2D3435;
            }
            & h4{
                color: #2D3435;
            }
            & h5{
                color: #2D3435;
            }
            & h6{
                color: #2D3435;
            }
            p {
                font-size: 16px;
                color: #2D3435
            }
            & span{
                color: #2D3435; 
            }
            & li{
                color: #2D3435;
                font-size: 16px;
            }

            & ul{
                padding-left: 20px;
                margin-top: 0px;
            }
        `,
    },
};

const styles = categorySpecificationStyles;

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

const CategorySpecification = ({ category, catalogPageState }: Props) => {
    if (!category) {
        return null;
    }

    const categoryKey = category?.name?.toLowerCase();
    if (!categoryKey) return null;
    const props = (catalogPageState?.value as any)?.properties || {};
    const categoryKeyLower = categoryKey.toLowerCase();

    const matchedKey = Object.keys(props).find(key => key.toLowerCase() === categoryKeyLower);

    const specificationHtml = matchedKey ? props[matchedKey] : undefined;
    if (!specificationHtml) return null;

    const transformedHtml = transformContentHtml(specificationHtml);

    return <StyledWrapper {...styles.wrapper}>{parse(transformedHtml, parserOptions)}</StyledWrapper>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(withCategory(CategorySpecification)),
    definition: {
        group: "Categories",
        icon: "folder-bookmark",
        displayName: "Category Specification Details",
        allowedContexts: ["CategoryDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
